import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { ReactNode } from 'react';
import { getObjTypesDropdown } from '@martech-solution/utils/apis';

interface Props {
  value?: number;
  style?: React.CSSProperties | undefined;
  allowClear?: boolean | undefined;
  onChange?: (value: number) => void;
  placeholder?: ReactNode;
  popupMatchSelectWidth?: number;
}

export default function ObjectTypeSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  popupMatchSelectWidth
}: Props) {
  const objectTypesDropdownQuery = useQuery({
    queryKey: ['objectTypesDropdown'],
    queryFn: () => getObjTypesDropdown(),
    staleTime: 60 * 1000
  });

  return (
    <Select
      popupMatchSelectWidth={popupMatchSelectWidth ?? 300}
      allowClear={allowClear}
      value={objectTypesDropdownQuery.isFetching ? undefined : value}
      style={style}
      placeholder={placeholder}
      optionLabelProp='selectedShow'
      onChange={onChange}
      options={objectTypesDropdownQuery.data?.data.map((data) => ({
        value: data.id,
        label: `${data.code} - ${data.name}`,
        selectedShow: `${data?.name}`
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={objectTypesDropdownQuery.isFetching}
    />
  );
}
